//import React from 'react';
import { styled } from 'styled-components';
import { WrapperRound } from '~/components/ui/wrapper-round';
//import { classic } from '~/themes/classic';
import bg from '@assets/images/background/dices.png';
import text from '@assets/images/background/dices-v.svg';

type IProps = {
  onClick?: () => void;
};

type TProps = IProps; // & ReturnType<typeof mapStateToProps> & TRootAction

export function RulesItem({ onClick }: TProps) {
  return (
    <WrapperRound onClick={onClick}>
      <SImgBgWR src={bg} alt="" />
      <SImgText>
        <img src={text} alt="" />
      </SImgText>
    </WrapperRound>
  );
}

const SImgBgWR = styled.img`
  position: absolute;
  right: -2px;
  top: -5px;
  object-fit: contain;
  height: 95%;
  width: 95%;
`;

const SImgText = styled.div`
  position: absolute;
  left: -2px;
  bottom: 3px;
  height: 60%;
  width: 70%;
  img {
    left: 0;
    bottom: 0;
    height: 100%;
    width: 100%;

    object-fit: contain;
  }
`;
